import { BLUEPRINTS_COLUMN_ID } from "../constants";
import BlueprintsTableUpdatedAtCell from "./UpdatedAtCell";
import BlueprintsTableRowActionsCell from "./RowActionsCell";
import BlueprintsTableSpaceCell from "./SpaceCell";
import BlueprintsTableLabelsCell from "./LabelsCell";
import BlueprintsTableNameCell from "./NameCell";
import BlueprintsTableDescriptionCell from "./DescriptionCell";
import BlueprintsTableStatusCell from "./StatusCell";

export const BLUEPRINTS_TABLE_CELLS = {
  [BLUEPRINTS_COLUMN_ID.NAME]: BlueprintsTableNameCell,
  [BLUEPRINTS_COLUMN_ID.DESCRIPTION]: BlueprintsTableDescriptionCell,
  [BLUEPRINTS_COLUMN_ID.STATUS]: BlueprintsTableStatusCell,
  [BLUEPRINTS_COLUMN_ID.SPACE]: BlueprintsTableSpaceCell,
  [BLUEPRINTS_COLUMN_ID.LABELS]: BlueprintsTableLabelsCell,
  [BLUEPRINTS_COLUMN_ID.UPDATED_AT]: BlueprintsTableUpdatedAtCell,
  [BLUEPRINTS_COLUMN_ID.DROPDOWN]: BlueprintsTableRowActionsCell,
};
